import { useState } from "react";
import { shape, string, bool, number, arrayOf, oneOfType } from "prop-types";

import ResponseInterface from "./ResponseInterface.jsx";

const propTypes = {
  userIsLoggedIn: bool.isRequired,
  responsesNumber: number,
  replies: arrayOf(
    shape({
      body: string.isRequired,
      authorName: string.isRequired,
      date: string,
      id: oneOfType([string, number]),
      authorOrganization: string,
    }),
  ),
  replyDepth: number,
  dictionary: shape({
    numberResponses: string,
  }),
};

const defaultProps = {
  replyDepth: Infinity,
};

const ReplyListing = (props) => {
  const { responsesNumber, replies, dictionary } = props;

  const [responseId, setResponseId] = useState(null);

  if (replies && replies.length <= 0) {
    return null;
  }

  const handleShowResponse = (id) => {
    setResponseId(id);
  };

  const handleCloseResponse = (id) => {
    setResponseId(null);
  };

  const renderReplies = ({ reply, parentAuthor = null, depth = 0 }) => {
    const { userIsLoggedIn, dictionary, replyDepth } = props;
    const { body, authorName, date, id, authorOrganization } = reply;

    const showReply = !!(userIsLoggedIn && depth < replyDepth);

    return (
      <li key={id} className="reply-listing__response reply-listing-item">
        <div className="reply-listing-item__response">
          <div
            className="reply-listing-item__message"
            dangerouslySetInnerHTML={{ __html: body }}
          />
          <div className="reply-listing-item__author-container">
            <div className="reply-listing-item__author">{authorName}</div>
            {parentAuthor && (
              <div className="reply-listing-item__reply-to">{`${dictionary.replyTo} ${parentAuthor}`}</div>
            )}
            <div className="reply-listing-item__date">{date}</div>
          </div>
          {authorOrganization && (
            <div className="reply-listing-item__organization">
              {authorOrganization}
            </div>
          )}
          {showReply && (
            <div className="reply-listing-item__reply-area">
              {responseId === id ? (
                <ResponseInterface
                  {...props}
                  authenticated={userIsLoggedIn}
                  parentId={id}
                  onRestart={handleCloseResponse}
                />
              ) : (
                <button
                  type="button"
                  onClick={() => handleShowResponse(id)}
                  className="btn link-style reply-listing-item__button"
                >
                  {dictionary.reply}
                </button>
              )}
            </div>
          )}
        </div>
        {reply.replies && (
          <ul className="reply-listing-item__sub-list">
            {reply.replies.map((reply) =>
              renderReplies({ reply, authorName, depth: depth + 1 }),
            )}
          </ul>
        )}
      </li>
    );
  };

  return (
    <section className="reply-listing">
      {responsesNumber > 0 && (
        <div className="reply-listing__count">{`${responsesNumber} ${dictionary.numberResponses}`}</div>
      )}
      {replies && (
        <ul className="reply-listing__items">
          {replies.map((reply) => renderReplies({ reply }))}
        </ul>
      )}
    </section>
  );
};

ReplyListing.propTypes = propTypes;
ReplyListing.defaultProps = defaultProps;
export default ReplyListing;
